import React, {Component} from "react";
import { HeaderWithControl } from "../../../common/titlewithbutton-layout/header-with-control";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { inventoryCircuitInvoiceActions } from "../../../../store/external/inventory/invoice/invoice.reducer";
import { ROUTE_LINK_LOCATION, INVENTORY_INVOICE_TAB_TITLE } from '../../../../constants/external-constants';
import { TRANSLATIONS as translation } from "../../../../utils/constant.utils";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";

class InvoiceCircuit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            invoiceTabPageLoaded: false,
        };
   
    }
    componentDidMount() {
        const { getInventoryCircuitInvoice, getInventoryCircuitDispute, circuitId, financeAccountId } = this.props;
        this.setState({ invoiceTabPageLoaded: false })
        getInventoryCircuitInvoice(circuitId, financeAccountId);
        getInventoryCircuitDispute(circuitId);
    }
    componentWillUnmount() {
        this.props.setDefaultInvoiceTab();
    }
    getInventoryCircuitInvoice = (pageIndex) => {
        const { getInventoryCircuitInvoice, circuitId, financeAccountId } = this.props;
        getInventoryCircuitInvoice(circuitId, financeAccountId, pageIndex);
    }
    componentDidUpdate(prevProps) {
        const { isInventoryCircuitInvoiceLoaded, isInventoryCircuitDisputeLoaded } = this.props;

        if ( !this.state.invoiceTabPageLoaded && isInventoryCircuitInvoiceLoaded && isInventoryCircuitDisputeLoaded &&
            (
                prevProps.isInventoryCircuitInvoiceLoaded !== isInventoryCircuitInvoiceLoaded ||
                prevProps.isInventoryCircuitDisputeLoaded !== isInventoryCircuitDisputeLoaded
            )
        ) {
            this.setState({ invoiceTabPageLoaded: true });
        }
    }
    onColumnSearchInvoice = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
        const { getInventoryCircuitInvoice, circuitId, financeAccountId } = this.props;
        getInventoryCircuitInvoice(circuitId, financeAccountId, 0);
    }
    onColumnSearchDispute = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
        const { getInventoryCircuitDispute, circuitId } = this.props;
        getInventoryCircuitDispute(circuitId, 0);
    }
    onColumnSortInvoice = (columnClicked, isSortedAsc) => {
        const { sortInventoryCircuitInvoice, circuitId, financeAccountId } = this.props;
        sortInventoryCircuitInvoice(columnClicked, isSortedAsc, circuitId, financeAccountId);
    }
    onColumnSortDispute = (columnClicked, isSortedAsc) => {
        const { sortInventoryCircuitDispute, circuitId } = this.props;
        sortInventoryCircuitDispute(columnClicked, isSortedAsc, circuitId);
    }
    displaySearchBox(value){
        this.setState(prevState => ({ 
            enableSearchBox: prevState.enableSearchBox === value ? null : value 
        }));
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onClickExtractInvoice = () => {
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            this.props.extractCircuitInvoice(this.props.circuitId, this.props.financeAccountId);
        }
    }
    onClickExtractDispute = () => {
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            this.props.extractCircuitDispute(this.props.circuitId);
        }
    }
    rowDisputeAction = (item, hasLink) => {
        if (hasLink && item.DisputeId) {
            window.open(`${ROUTE_LINK_LOCATION.invoiceDisputeDetailsLink}/${item.DisputeId}`, "_blank")

        } else {
            this.setState({ showModal: true, selectedItem: item })
        }
    }
    rowInvoiceAction = (item, hasLink) => {
        if (hasLink && item.InvoiceId) {
            window.open(`${ROUTE_LINK_LOCATION.invoiceRouteLink}/${item.InvoiceId}`, "_blank")

        } else {
            this.setState({ showModal: true, selectedItem: item })
        }
    }
    loading = () => {
        return (
            <NoSubscription />
        );
    }
    render() {
        const {
            inventoryCircuitInvoice,
            setInventoryCircuitInvoiceColSearchStr,
            getInventoryCircuitDispute,
            setInventoryCircuitDisputeColSearchStr,
            isReadOnly,
            isReadAndExtractOnly,
            isReadAndWrite,
            circuitId
        } = this.props;

        const {
            inventoryCircuitInvoiceItems,
            inventoryCircuitDisputeItems
        } = inventoryCircuitInvoice;

        const commonHeaderProps = {
            displaySearchBox: this.displaySearchBox.bind(this),
            isReadOnly,
            isReadAndExtractOnly,
            isReadAndWrite
        };

        const commonTableProps = {
            onColumnClick: this.onColumnSortInvoice,
            isNotSortable: false,
            isLoading: false,
            haveLink: true,
            hidePageSizeSelection: true,
            resizePage: () => { }
        };

        if (!this.state.invoiceTabPageLoaded) {
            return this.loading();
        }

        return (
            <div className="details-container">
                <HeaderWithControl
                    title={INVENTORY_INVOICE_TAB_TITLE.Invoices}
                    extractAction={this.onClickExtractInvoice}
                    {...commonHeaderProps}
                >
                    <TablePagination
                        key="table-pagination-key"
                        columns={inventoryCircuitInvoiceItems.Headers}
                        pageList={inventoryCircuitInvoiceItems.Data.Items}
                        pages={inventoryCircuitInvoiceItems.Pagination}
                        rowClickAction={this.rowInvoiceAction}
                        paginationAction={this.getInventoryCircuitInvoice}
                        onColumnSearch={this.onColumnSearchInvoice}
                        onColumnSearchChange={setInventoryCircuitInvoiceColSearchStr}
                        isColSearchShow={this.state.enableSearchBox === INVENTORY_INVOICE_TAB_TITLE.Invoices}
                        totalPage={inventoryCircuitInvoiceItems.Pagination.TotalEntries}
                        {...commonTableProps}
                    />
                </HeaderWithControl>
                <div className="horizontal-separator seprator-margin-bottom-top"></div>
                <HeaderWithControl
                    title={INVENTORY_INVOICE_TAB_TITLE.Disputes}
                    extractAction={this.onClickExtractDispute}
                    {...commonHeaderProps}
                >
                    <TablePagination
                        key="table-pagination-key"
                        columns={inventoryCircuitDisputeItems.Headers}
                        pageList={inventoryCircuitDisputeItems.Data.Items}
                        pages={inventoryCircuitDisputeItems.Pagination}
                        rowClickAction={this.rowDisputeAction}
                        paginationAction={(value) => getInventoryCircuitDispute(circuitId, value)}
                        onColumnSearch={this.onColumnSearchDispute}
                        onColumnSearchChange={setInventoryCircuitDisputeColSearchStr}
                        isColSearchShow={this.state.enableSearchBox === INVENTORY_INVOICE_TAB_TITLE.Disputes}
                        totalPage={inventoryCircuitDisputeItems.Pagination.TotalEntries}
                        noAvailableData={true}
                        {...commonTableProps}
                    />
                </HeaderWithControl>
            </div>
        );
    }
}

export default connect(
    state => {
        const { inventoryCircuitInvoice, translation } = state;

        return {
            inventoryCircuitInvoice,
            ...translation,
            isInventoryCircuitInvoiceLoaded: inventoryCircuitInvoice.isInventoryCircuitInvoiceLoaded,
            isInventoryCircuitDisputeLoaded: inventoryCircuitInvoice.isInventoryCircuitDisputeLoaded,
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitInvoiceActions),
        dispatch
    )
)(InvoiceCircuit);